import script from "./LoadingDots.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingDots.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingDots.vue?vue&type=style&index=0&id=7113a828&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7113a828"]])

export default __exports__